import React, { useMemo } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import { Button } from "components/ui";
import clsx from "clsx";

export const CustomCalendar = ({
  currentDate,
  onPrev,
  onNext,
  dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  renderDay,
  hideHeader = false,
  className,
  dayHeaderClassName,
  dayNameClassName,
  gridClassName,
  gridWrapperClassName,
}) => {
  // Generate calendar days for month grid (42 days)
  const calendarDays = useMemo(() => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();

    const firstDay = new Date(year, month, 1);
    const startDayOfWeek = firstDay.getDay();
    const startDate = new Date(firstDay);
    startDate.setDate(firstDay.getDate() - startDayOfWeek);

    const days = [];
    const current = new Date(startDate);

    for (let i = 0; i < 42; i++) {
      days.push({
        date: new Date(current),
        isCurrentMonth: current.getMonth() === month,
        isToday: current.toDateString() === new Date().toDateString(),
      });
      current.setDate(current.getDate() + 1);
    }
    return days;
  }, [currentDate]);

  return (
    <div className={className}>
      {/* Calendar Navigation */}
      {!hideHeader && (
        <div className="mt-3 mb-4 flex items-center justify-between">
          <Button variant="outlined" size="sm" onClick={onPrev}>
            <ChevronLeftIcon className="h-4 w-4" />
          </Button>

          <h4 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
            {currentDate.toLocaleDateString("en-US", {
              month: "long",
              year: "numeric",
            })}
          </h4>

          <Button variant="outlined" size="sm" onClick={onNext}>
            <ChevronRightIcon className="h-4 w-4" />
          </Button>
        </div>
      )}

      <div className={gridWrapperClassName}>
        {/* Day Headers */}
        <div className={dayHeaderClassName}>
          {dayNames.map((day) => (
            <div key={day} className={dayNameClassName}>
              {day}
            </div>
          ))}
        </div>

        {/* Days Grid */}
        <div className={clsx("grid grid-cols-7", gridClassName)}>
          {calendarDays.map((day, index) => renderDay(day, index))}
        </div>
      </div>
    </div>
  );
};

export default CustomCalendar;
